import { Box, Grid, TextField } from "@material-ui/core";
import { useFormik } from "formik";
import * as React from "react";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import {
  getInventoryItemStatusListingAction,
  getWareHouseDetailsByIdAction,
  getWareHouseListingAction,
  updateInventoryItemAction,
} from "src/app-redux/warehouse/actions/wareHouseActions";
import {
  selectInventoryItemStatusListing,
  selectWareHouseItemDetails,
  selectWareHouseListing,
} from "src/app-redux/warehouse/wareHouseSlice";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import { object, string } from "yup";
import { useStyles } from "./../style";

export interface IDrawerStatusProps {}

export default function DrawerStatus(props: IDrawerStatusProps) {
  const inspectionStatusLinst = [
    { id: 1, name: "Passed" },
    { id: 0, name: "Failed" },
    { id: 2, name: "Detained" },
    { id: 3, name: "Other" },
  ];
  const classes = useStyles();
  const inventoryItemDetails: any = useAppSelector(selectWareHouseItemDetails);
  const dispatch = useAppDispatch();
  const validationSchema = object({
    inspectionStatus: string().required("This field is required"),
    warehouseId: string().required("This field is required"),
    statusId: string().required("This field is required."),
    remarks: string().max(3000, "Maximum 3000 characters are allowed"),
  });
  const formik = useFormik<any>({
    enableReinitialize: true,
    initialValues: {
      inventoryId: inventoryItemDetails.itemDetail?.id || "",
      statusId: inventoryItemDetails.itemDetail?.statusId || "",
      gatePassId: inventoryItemDetails.itemDetail?.gatePassId || 0,
      warehouseId: parseInt(inventoryItemDetails.itemDetail?.warehouseId) || "",
      inspectionStatus: inventoryItemDetails.itemDetail?.inspectionStatus || "0",
      remarks: inventoryItemDetails.itemDetail?.remarks || "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any, actions) => {
      const inspectionStatusId = await inspectionStatusLinst.find(
        (value) => value.name === values.inspectionStatus
      )?.id;
      values.inspectionStatus = inspectionStatusId;
      const res: any = await dispatch(updateInventoryItemAction(values));
      if (res.payload) {
        actions.setSubmitting(false);
        dispatch(getWareHouseDetailsByIdAction(inventoryItemDetails.itemDetail?.id));
        return;
      }
    },
  });
  // Redux
  const wareHouseListing = useAppSelector(selectWareHouseListing);
  const inventoryItemStatusListing = useAppSelector(selectInventoryItemStatusListing);
  React.useEffect(() => {
    if (wareHouseListing.length === 0) dispatch(getWareHouseListingAction());
    if (inventoryItemStatusListing.length === 0) dispatch(getInventoryItemStatusListingAction());
  }, []);
  const resetStatusForm = () => {
    formik.setFieldValue("statusId", "");
    formik.setFieldValue("warehouseId", "");
    formik.setFieldValue("inspectionStatus", "");
    formik.setFieldValue("remarks", "");
  };
  return (
    <div className={classes.drawerDetails}>
      {/* Drawer Status Item  */}
      <Grid container spacing={2} className="topContainer">
        <Grid container direction="row" className="itemRow" spacing={2}>
          <Grid item xs={12} md={12}>
            <Box>
              <CommonAutoCompleteField
                cssClassName="customTextField"
                label="Item Status"
                placeholder="Item Status"
                name="statusId"
                optionsType={inventoryItemStatusListing}
                required
                getOptionLabel={(option: any) => option.status || ""}
                value={
                  inventoryItemStatusListing.find((st: any) => st.id === formik.values.statusId) ||
                  null
                }
                onChange={(option: any) => {
                  option && option.id !== 0 ? formik.setFieldValue("statusId", option.id) : "";
                }}
                error={formik.touched.statusId && Boolean(formik.errors.statusId)}
                helperText={formik.touched.statusId && formik.errors.statusId}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box>
              <CommonAutoCompleteField
                cssClassName="customTextField"
                error={formik.touched.warehouseId && Boolean(formik.errors.warehouseId)}
                helperText={formik.touched.warehouseId && formik.errors.warehouseId}
                label="Warehouse"
                placeholder="Warehouse"
                name="warehouseId"
                optionsType={wareHouseListing}
                required
                getOptionLabel={(option: any) => option.name || ""}
                value={
                  wareHouseListing.find((st: any) => st.id === formik.values.warehouseId) || null
                }
                onChange={(option: any) => {
                  option && option.id !== 0 ? formik.setFieldValue("warehouseId", option.id) : "";
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            {/* <Box>
              <FormControl
                component="fieldset"
                // error={error}
              >
                <FormLabel component="legend" className={classes.legend}>
                  Inspection Status
                </FormLabel>
                <RadioGroup
                  row
                  aria-label="gender"
                  name="gender1"
                  value={formik.values.inspectionStatus}
                  onChange={(event: any) => {
                    formik.setFieldValue("inspectionStatus", event.target.value);
                  }}
                >
                  <FormControlLabel value="Passed" control={<Radio />} label="Passed" />
                  <FormControlLabel value="Failed" control={<Radio />} label="Failed" />
                </RadioGroup>
              </FormControl>
            </Box> */}
            <Box>
              <CommonAutoCompleteField
                cssClassName="customTextField"
                error={formik.touched.inspectionStatus && Boolean(formik.errors.inspectionStatus)}
                helperText={formik.touched.inspectionStatus && formik.errors.inspectionStatus}
                label="Inspection Status"
                placeholder="Inspection Status"
                name="InspectionStatus"
                optionsType={inspectionStatusLinst}
                getOptionLabel={(option: any) => option.name || ""}
                value={
                  inspectionStatusLinst.find(
                    (st: any) => st.name === formik.values.inspectionStatus
                  ) || null
                }
                onChange={(option: any) => {
                  formik.setFieldValue("inspectionStatus", option.name);
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: "20px" }}>
            <Box>
              <TextField
                className={"customTextField"}
                multiline
                rows={2}
                rowsMax={5}
                size="small"
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Remarks"
                name="remarks"
                placeholder="Remarks"
                disabled={false}
                value={formik.values.remarks}
                onChange={formik.handleChange}
                error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                helperText={formik.touched.remarks && formik.errors.remarks}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box textAlign="left" mt={1}>
              <CommonButton
                cssClass="customSubmitBtn"
                onClick={() => {
                  resetStatusForm();
                }}
              >
                Reset
              </CommonButton>
              <CommonButton
                cssClass="customSubmitBtn"
                isGreen
                disable={JSON.stringify(formik.values) === JSON.stringify(formik.initialValues)}
                onClick={() => {
                  formik.submitForm();
                }}
              >
                Update
              </CommonButton>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
